import { makeActionCreator } from '../../utils';
import { authActionTypes } from '../actionTypes';

// AUTH ACTION CREATORS

/**
 * Create an action creator that sets the auth token
 * @constant
 * @type {function} updateAuthToken action creator
 */
export const updateAuthToken = makeActionCreator(authActionTypes.UPDATE_AUTH_TOKEN, 'authToken');


// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/actions/actionCreators/authActionCreators.js